export const ONBOARDING_AMPLITUDE_USER_PROPERTY = {
	SIGN_UP_METHOD: 'sign up method',
};
